/**
 * @desc 获取拥有该权限的用户
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<
  defs.appCenter.IPage<defs.appCenter.UserResponseDto>
>;
export function request(
  code: string,
  params: API.appCenter.role.getUserListByRoleCode.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/role/user/${code}`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
